var _path, _path2, _linearGradient;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconArrowLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 56,
    viewBox: "0 0 32 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.43855 27.6546L29.2805 2.69472L28.5612 2L2 27.6546L2.71928 28.3493L29.2805 54.0039L29.9998 53.3092L3.43855 27.6546Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2805 2.69472L30.3226 3.77364C30.6152 3.49099 30.7805 3.10158 30.7805 2.69472C30.7805 2.28787 30.6152 1.89846 30.3226 1.61581L29.2805 2.69472ZM3.43855 27.6546L2.39647 26.5757C2.10382 26.8583 1.93855 27.2477 1.93855 27.6546C1.93855 28.0614 2.10382 28.4508 2.39647 28.7335L3.43855 27.6546ZM28.5612 2L29.6033 0.921086C29.022 0.359638 28.1004 0.359638 27.5191 0.921086L28.5612 2ZM2 27.6546L0.957914 26.5757C0.665271 26.8583 0.5 27.2477 0.5 27.6546C0.5 28.0614 0.665271 28.4508 0.957913 28.7335L2 27.6546ZM2.71928 28.3493L1.67719 29.4282L1.67719 29.4282L2.71928 28.3493ZM29.2805 54.0039L28.2384 55.0828C28.8197 55.6443 29.7413 55.6443 30.3226 55.0828L29.2805 54.0039ZM29.9998 53.3092L31.0419 54.3881C31.3345 54.1054 31.4998 53.716 31.4998 53.3092C31.4998 52.9023 31.3345 52.5129 31.0419 52.2303L29.9998 53.3092ZM28.2384 1.61581L2.39647 26.5757L4.48064 28.7335L30.3226 3.77364L28.2384 1.61581ZM27.5191 3.07891L28.2384 3.77364L30.3226 1.61581L29.6033 0.921086L27.5191 3.07891ZM3.04209 28.7335L29.6033 3.07891L27.5191 0.921086L0.957914 26.5757L3.04209 28.7335ZM3.76136 27.2704L3.04209 26.5757L0.957913 28.7335L1.67719 29.4282L3.76136 27.2704ZM30.3226 52.925L3.76136 27.2704L1.67719 29.4282L28.2384 55.0828L30.3226 52.925ZM28.9577 52.2303L28.2384 52.925L30.3226 55.0828L31.0419 54.3881L28.9577 52.2303ZM2.39647 28.7335L28.9577 54.3881L31.0419 52.2303L4.48064 26.5757L2.39647 28.7335Z",
    fill: "current"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3580e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#8579f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b578ef"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowLeft);
export default __webpack_public_path__ + "static/media/icon-arrow-left.a01511153bec959927ccee75854d0c15.svg";
export { ForwardRef as ReactComponent };